import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { Context } from "../../../utils/context";
import ReferralTree from "./referral_tree/ReferralTree";

const Referal = () => {
  const [loading, setLoading] = useState(true);
  const [selectedLevel, setSelectedLevel] = useState(0);

  const [selectedLevelUsers, setSelectedLevelUsers] = useState([]);
  const navigate = useNavigate();

  // const id = props.show;
  const { id } = useParams();
  const { postData, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const [data, setData] = useState({});
  const GetEditData = async () => {
    try {
      setLoading(true);

      const response = await getData(
        `/admin/customer/referral-users/${id}?level_id=${
          selectedLevel > 0 ? selectedLevel : ""
        }`,
      );

      setData(response?.data || {});
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const [level, setLevel] = useState([]);

  const getAllLevel = async () => {
    try {
      const response = await getData(`/common/masters/all-level`);

      if (response?.success) {
        setLevel([
          {
            id: 0,
            name: "Total",
          },
          ...(response?.data || []),
        ]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);

      try {
        await Promise.all([GetEditData(), getAllLevel()]);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [selectedLevel]);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "80vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <section className="Create">
      <div className="back_btn_holder">
        <div onClick={() => navigate(`/customers`)}>
          <FontAwesomeIcon className="back-btn" icon={faAngleLeft} />
          Back
        </div>
      </div>
      {/* <div
                style={{
                    padding: "20px",
                    background: "#f5f5f5",
                    minHeight: "100vh",
                }}
            > */}

      <div
        style={{
          background: "linear-gradient(135deg, #b8d7ff 0%, #5ca7ff 100%)",
          padding: "20px",
          borderRadius: "10px",
          marginBottom: "20px",
        }}
      >
        <Row>
          <Col md={3}>
            <div style={{ marginBottom: "8px" }}>
              <div style={{ fontWeight: "600" }}>Customer Name</div>

              <div>{data?.User?.name}</div>
            </div>

            <div style={{ marginBottom: "8px" }}>
              <div style={{ fontWeight: "600" }}>Customer Number</div>

              <div>{data?.User?.contact_no}</div>
            </div>

            <div>
              <div style={{ fontWeight: "600" }}>Total Bonus</div>

              <div>{data?.User?.total_commission || 0}</div>
            </div>
          </Col>
        </Row>
      </div>

      <ReferralTree customerId={id} />

      {/* </div> */}
    </section>
  );
};

export default Referal;
